import { t } from '@lingui/macro';
import ContentWrapper from 'components/ContentWrapper';
import { Grid, GridItem } from 'components/Grid';
import { Meta } from 'components/Meta';
import { SanityImage } from 'components/SanityImage';
import { resolveArticleUrl } from 'helpers/url';
import { getClient } from 'lib/sanity/sanity.server';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { SanitySlug } from 'types/sanity';
import { Linktree } from 'types/schema';

type LinkTree = Omit<Linktree, 'blogPost'> & {
  blogPost: {
    slug: SanitySlug;
    alt: string;
    categories: { _id: string; _type: string; isPage?: boolean; slug?: SanitySlug }[];
  };
};

interface InstagramPageProps {
  linktree: LinkTree[];
}

const InstagramPage = ({ linktree }: InstagramPageProps) => {
  const router = useRouter();
  return (
    <>
      <Meta title={t`Firi current posts`} />
      <ContentWrapper constrained className="my-10">
        <Grid>
          {linktree.map((link) => {
            if (!link.cardImage?.asset) return null;
            const url = link.href || resolveArticleUrl({ ...link.blogPost }, router.locale ?? '');
            return (
              <GridItem key={link._id} className="md:col-span-3 lg:col-span-4">
                <Link href={url ?? ''}>
                  <a>
                    <div className="w-full relative after:block after:pt-[100%] overflow-hidden">
                      <SanityImage
                        source={link.cardImage}
                        alt={link.blogPost?.alt}
                        objectFit="cover"
                        objectPosition="center"
                        layout="fill"
                        sizes="300px"
                      />
                    </div>
                  </a>
                </Link>
              </GridItem>
            );
          })}
        </Grid>
      </ContentWrapper>
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  const linktree = await getClient(preview).fetch(`*[_type == "linktree"] | order(_createdAt desc) {
        ...,
        blogPost -> { slug, alt, categories[]-> }
      }`);

  return {
    props: { linktree },
    revalidate: 600,
  };
};

export default InstagramPage;
